<template>
  <div class="container">
    <!-- 总收入卡片 -->
    <div class="total-income-card">
      <div class="total-income-bg"></div>
      <div class="total-income-content">
        <div class="total-income-label">本年度总收入（{{ currentYear }}年）</div>
        <div class="total-income-value">{{ formatMoney(totalIncomeValue) }}</div>
      </div>
    </div>

    <!-- Tab切换 -->
    <div class="custom-tabs">
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'property' }"
        @click="switchTab('property')"
      >
        <img :src="activeTab === 'property' ? require('../../assets/newicon/wyfwf_a.png') : require('../../assets/newicon/wyfwf.png')" alt="物业费" />
        <span class="tab-title">物业费</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.property.income) }}</span>
      </div>
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'public' }"
        @click="switchTab('public')"
      >
        <img :src="activeTab === 'public' ? require('../../assets/newicon/ggsy_a.png') : require('../../assets/newicon/ggsy.png')" alt="公共收益" />
        <span class="tab-title">公共收益</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.public.income) }}</span>
      </div>
      <div
        class="custom-tab"
        :class="{ active: activeTab === 'agency' }"
        @click="switchTab('agency')"
      >
        <img :src="activeTab === 'agency' ? require('../../assets/newicon/dsfhs_a.png') : require('../../assets/newicon/dsfhs.png')" alt="代收代交费" />
        <span class="tab-title">代收代交费</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.agency.income) }}</span>
      </div>
      <!-- <div
        class="custom-tab"
        :class="{ active: activeTab === 'parking' }"
        @click="switchTab('parking')"
      >
        <img :src="activeTab === 'parking' ? require('../../assets/newicon/rfcwzj_a.png') : require('../../assets/newicon/rfcwzj.png')" alt="人防车位租金" />
        <span class="tab-title">人防车位租金</span>
        <span class="tab-amount">{{ formatMoneyShort(tabData.parking.income) }}</span>
      </div> -->
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-label-left">选择时间</div>
        <div class="filter-time-content">
          <div class="time-item" @click="showStartPicker = true">
            <span class="time-value">{{ startDate || '开始时间' }}</span>
            <img class="time-icon" src="../../assets/newicon/rl.png" alt="日历" />
          </div>
          <div class="time-divider">~</div>
          <div class="time-item" @click="showEndPicker = true">
            <span class="time-value">{{ endDate || '结束时间' }}</span>
            <img class="time-icon" src="../../assets/newicon/rl.png" alt="日历" />
          </div>
        </div>
      </div>
      <!-- 只有公共收益Tab才显示收入类型筛选 -->
      <template v-if="activeTab === 'public'">
        <div class="filter-divider"></div>
        <div class="filter-row">
          <div class="filter-label-left">收入类型</div>
          <div class="filter-type-content" @click="showTypePicker = true">
            <span class="type-value">{{ incomeTypeName || '全部' }}</span>
            <van-icon name="arrow-down" size="14" color="#666" />
          </div>
        </div>
      </template>
    </div>

    <!-- 数据卡片 -->
    <!-- <div class="data-cards">
      <div class="data-card">
        <div class="card-icon">
          <img src="../../assets/newicon/sz.png" alt="收入" />
        </div>
        <div class="card-info">
          <div class="card-label">本年度收入</div>
          <div class="card-value">{{ formatMoney(currentTabData.income) }}</div>
        </div>
      </div>
      <div class="data-card">
        <div class="card-icon">
          <img src="../../assets/newicon/sz.png" alt="支出" />
        </div>
        <div class="card-info">
          <div class="card-label">本年度支出</div>
          <div class="card-value">{{ formatMoney(currentTabData.expense) }}</div>
        </div>
      </div>
      <div class="data-card">
        <div class="card-icon">
          <img src="../../assets/newicon/sz.png" alt="结余" />
        </div>
        <div class="card-info">
          <div class="card-label">本年度结余</div>
          <div class="card-value">{{ formatMoney(currentTabData.balance) }}</div>
        </div>
      </div>
    </div> -->

    <!-- 收入列表 -->
    <div class="income-list">
      <div class="section-header">
        <h2 class="section-title">收入明细</h2>
        <span class="section-count">共{{ total }}条记录</span>
      </div>
      <van-loading v-if="loading" class="loading" />
      <div v-else-if="filteredList.length === 0" class="empty-state">
        <van-icon name="balance-pay" size="48" color="#999" />
        <div class="empty-text">暂无收入记录</div>
        <div class="empty-hint">请尝试调整筛选条件</div>
      </div>
      <div v-else>
        <div
          class="income-card"
          v-for="item in filteredList"
          :key="item.id"
        >
          <div class="income-info">
            <div class="income-title">
              <span>{{ item.title }}</span>
              <span class="income-amount">{{ formatMoney(item.amount) }}</span>
            </div>
            <div class="income-meta">
              <div class="income-meta-item">
                <span class="meta-label">所属小区：</span>
                <span class="meta-value">{{ item.community }}</span>
              </div>
              <div class="income-meta-item">
                <span class="meta-label">收入类型：</span>
                <span class="meta-value">{{ item.typeName }}</span>
              </div>
              <div class="income-meta-item">
                <span class="meta-label">收入所属时间：</span>
                <span class="meta-value">{{ item.date }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 日期选择器 -->
    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onStartConfirm"
        @cancel="showStartPicker = false"
      />
    </van-popup>
    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onEndConfirm"
        @cancel="showEndPicker = false"
      />
    </van-popup>

    <!-- 类型选择器 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @confirm="onTypeConfirm"
        @cancel="showTypePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import axios from '@/utils/request'

export default {
  name: 'SzmxSr',
  data() {
    return {
      loading: false,
      activeTab: '',
      currentYear: new Date().getFullYear(),
      totalIncomeValue: 0,
      startDate: '',
      endDate: '',
      showStartPicker: false,
      showEndPicker: false,
      showTypePicker: false,
      incomeType: '',
      incomeTypeName: '全部',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 31),
      // 各Tab数据
      tabData: {
        property: { income: 0, expense: 0, balance: 0 },
        public: { income: 0, expense: 0, balance: 0 },
        agency: { income: 0, expense: 0, balance: 0 },
        parking: { income: 0, expense: 0, balance: 0 }
      },
      // 收入类型配置（从接口获取）
      typeOptions: [],
      // 当前选中的子类型
      subType: '',
      // 收入明细列表
      incomeList: [],
      // 分页信息
      pageNum: 0,
      pageSize: 100,
      total: 0
    }
  },
  computed: {
    currentTabData() {
      return this.tabData[this.activeTab] || { income: 0, expense: 0, balance: 0 }
    },
    filteredList() {
      // 根据当前Tab筛选列表
      return this.incomeList
    },
    typeColumns() {
      // 只有公共收益Tab显示收入类型筛选
      if (this.activeTab === 'public' && this.typeOptions.length > 0) {
        // 添加"全部"选项
        return ['全部', ...this.typeOptions.map(item => item.subTypeName)]
      }
      return []
    },
    // 公共收益的子类型列表（包含"全部"选项）
    publicSubTypes() {
      if (this.typeOptions.length > 0) {
        return [{ subTypeCode: '', subTypeName: '全部' }, ...this.typeOptions]
      }
      return [{ subTypeCode: '', subTypeName: '全部' }]
    },
  },
  mounted() {
    this.initPage()
  },
  methods: {
    async initPage() {
      // 设置默认日期范围
      this.startDate = `${this.currentYear}-01-01`
      this.endDate = `${this.currentYear}-12-31`

      // 并行加载数据
      await Promise.all([
        this.loadSummary(),
        this.loadTypes(),
        this.loadList()
      ])

      // 固定本年度总收入，不随日期筛选变化
      this.totalIncomeValue = this.tabData.property.income + this.tabData.public.income + this.tabData.agency.income + this.tabData.parking.income
      this.loading = false
    },
    // 加载收入汇总（tab金额随日期变化）
    async loadSummary() {
      try {
        const params = {}
        if (this.startDate) params.startDate = this.startDate
        if (this.endDate) params.endDate = this.endDate
        if (!this.startDate && !this.endDate) {
          params.year = this.currentYear
        }
        const res = await axios.get('/api/v1/workstation/wyfSr/summary', { params })
        if (res) {
          // 物业费
          this.tabData.property.income = res.ownerPayment || 0
          // 公共收益
          this.tabData.public.income = res.publicBenefit || 0
          // 其他（代收代交费）
          this.tabData.agency.income = res.other || 0
          // 计算结余（这里暂时设为0，实际应根据接口返回）
          this.tabData.property.balance = this.tabData.property.income - (res.ownerExpense || 0)
          this.tabData.public.balance = this.tabData.public.income - (res.publicExpense || 0)
          this.tabData.agency.balance = this.tabData.agency.income - (res.otherExpense || 0)
        }
      } catch (error) {
        console.error('加载收入汇总失败:', error)
      }
    },
    // 加载收入类型列表
    async loadTypes() {
      try {
        const res = await axios.get('/api/v1/workstation/wyfSr/types')
        console.log('=== /api/v1/workstation/wyfSr/types 接口返回 ===')
        console.log(JSON.stringify(res[1].subTypes, null, 2))
        if (res && Array.isArray(res)) {
          this.typeOptions = res[1].subTypes
        }
      } catch (error) {
        console.error('加载收入类型失败:', error)
      }
    },
    // 获取当前Tab对应的收入类型（空表示全部)
    getIncomeTypeByTab() {
      if (!this.activeTab) return ''  // 没选择tab时返回空，表示查询全部
      const typeMap = {
        'property': '1',  // 物业费 -> 业主缴纳
        'public': '2',     // 公共收益
        'agency': '3',     // 代收代交费 -> 其他
        'parking': '4'     // 人防车位租金
      }
      return typeMap[this.activeTab] || ''
    },
    // 加载收入明细列表
    async loadList() {
      // 人防车位租金暂无数据，显示空列表
      if (this.activeTab === 'parking') {
        this.incomeList = []
        this.total = 0
        return
      }
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        if (this.startDate) params.startDate = this.startDate
        if (this.endDate) params.endDate = this.endDate
        // 根据当前Tab传递收入类型
        const incomeType = this.getIncomeTypeByTab()
        if (incomeType) params.incomeType = incomeType
        // 公共收益Tab传递子类型参数
        if (this.activeTab === 'public' && this.subType) {
          params.subType = this.subType
        }

        const res = await axios.get('/api/v1/workstation/wyfSr/list', { params })
        if (res && res.data) {
          this.incomeList = res.data.map(item => ({
            id: item.id,
            title: item.title,
            amount: item.amount,
            type: item.incomeType,
            typeName: item.incomeTypeName,
            subType: item.subType,
            subTypeName: item.subTypeName,
            community: item.villageName,
            date: item.incomeDate,
            startMonth: item.startMonth,
            endMonth: item.endMonth,
            payTime: item.payTime,
            address: item.address,
            ownerName: item.ownerName
          }))
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('加载收入明细失败:', error)
        this.incomeList = []
      }
    },
    switchTab(tab) {
      this.activeTab = tab
      // 切换Tab时重置筛选条件
      this.subType = ''
      this.incomeTypeName = '全部'
      // 设置默认日期范围
      if (!this.startDate) {
        this.startDate = `${this.currentYear}-01-01`
      }
      if (!this.endDate) {
        this.endDate = `${this.currentYear}-12-31`
      }
      this.loadList()
    },
    // 筛选条件变化时重新加载整个页面数据
    async onFilterChange() {
      this.loading = true
      await Promise.all([
        this.loadSummary(),
        this.loadList()
      ])
      this.loading = false
    },
    formatMoney(value) {
      if (!value && value !== 0) return '¥0'
      return '¥' + value.toLocaleString()
    },
    formatMoneyShort(value) {
      if (!value && value !== 0) return '0'
      if (value >= 10000) {
        return (value / 10000).toFixed(1) + '万'
      }
      return value.toLocaleString()
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onStartConfirm(value) {
      this.startDate = this.formatDate(value)
      this.showStartPicker = false
      this.onFilterChange()
    },
    onEndConfirm(value) {
      this.endDate = this.formatDate(value)
      this.showEndPicker = false
      this.onFilterChange()
    },
    onTypeConfirm(value, index) {
      this.incomeTypeName = value
      // 公共收益Tab使用subTypes
      if (this.activeTab === 'public') {
        this.subType = this.publicSubTypes[index].subTypeCode
      }
      this.showTypePicker = false
      this.onFilterChange()
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.total-income-card {
  margin: 16px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  height: 120px;
}

.total-income-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('../../assets/newicon/sz.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.total-income-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px 0 74px;
  color: white;
}

.total-income-label {
  font-size: 15px;
  line-height: 23px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.total-income-value {
  font-size: 24px;
  font-weight: 700;
}

.custom-tabs {
  display: flex;
  // background-color: #fff;
  padding: 0 16px;
  gap: 12px;
}

.custom-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  img {
    width: 23px;
    height: 23px;
    object-fit: contain;
  }

  span {
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }

  .tab-title {
    font-size: 13px;
    font-weight: 500;
    // text-align: center;
    min-height: 34px;
    display: flex;
    align-items: center;
  }
  
  .tab-amount {
    font-size: 15px;
    font-weight: 700;
    color: #333;
  }

  &.active {
    background-color: #4892FB;
    box-shadow: 0 4px 12px rgba(72, 146, 251, 0.3);

    span {
      color: #fff;
    }

    .tab-amount {
      color: #fff;
    }
  }
}

.filter-section {
  background-color: #fff;
  border-radius: 12px;
  padding: 16px;
  margin: 12px 16px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.filter-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.filter-label-left {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  width: 70px;
  flex-shrink: 0;
}

.filter-time-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.time-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.time-value {
  font-size: 14px;
  color: #333;
}

.time-icon {
  width: 14px;
  height: 14px;
}

.time-divider {
  padding: 0 8px;
  font-size: 14px;
  color: #666;
}

.filter-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 8px 0;
}

.filter-type-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  gap: 4px;
}

.type-value {
  font-size: 14px;
  color: #333;
}

.data-cards {
  display: flex;
  padding: 16px;
  gap: 12px;
}

.data-card {
  flex: 1;
  background-color: #fff;
  border-radius: 12px;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(72, 146, 251, 0.15);
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #4892FB;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
}

.card-info {
  text-align: center;
}

.card-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.card-value {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.income-list {
  padding: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.section-count {
  font-size: 12px;
  color: #7F7F7F;
}

.loading {
  text-align: center;
  padding: 32px 16px;
}

.empty-state {
  text-align: center;
  padding: 48px 16px;
  color: #999;
}

.empty-text {
  font-size: 16px;
  margin: 16px 0 8px;
}

.empty-hint {
  font-size: 14px;
}

.income-card {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 16px;
}

.income-info {
  width: 100%;
}

.income-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.income-amount {
  font-size: 14px;
  font-weight: normal;
  color: #1890ff;
}

.income-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.income-meta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.meta-label {
  font-size: 13px;
  color: #999;
}

.meta-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
</style>
